import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const KEY = "cd_fav_activities";
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};
const write = (v) => {
  localStorage.setItem(KEY, JSON.stringify(v));
  window.dispatchEvent(new Event("cd-favs"));
};

export function useFavorites() {
  const [favs, setFavs] = useState(read);

  useEffect(() => {
    const h = () => setFavs(read());
    window.addEventListener("cd-favs", h);
    return () => window.removeEventListener("cd-favs", h);
  }, []);

  // Sync with the logged-in account. Server is source of truth (last-write-wins,
  // so a removal on another device propagates); first-ever sync pushes local up.
  useEffect(() => {
    let done = false;
    api.get("/me/favorites").then((r) => {
      if (done) return;
      const server = r.data.favorites || [];
      const local = read();
      if (server.length === 0 && local.length > 0) {
        api.put("/me/favorites", { favorites: local }).catch(() => {});
      } else {
        write(server);
        setFavs(server);
      }
    }).catch(() => {});
    return () => { done = true; };
  }, []);

  const toggle = useCallback((id) => {
    const cur = read();
    const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
    write(next);
    setFavs(next);
    api.put("/me/favorites", { favorites: next }).catch(() => {});
  }, []);

  const isFav = useCallback((id) => favs.includes(id), [favs]);
  return { favs, toggle, isFav };
}
